<template>
  <b-container v-if="type && models" fluid>
    <page-title icon="fas fa-file-alt">
      <translate>Shipment Orders</translate>
      <template #extras>
        <b-button variant="secondary" size="sm" :to="{name: 'ShippingOrdersCreate'}">
          <font-awesome-icon icon="plus-circle" />
          <translate>New Order</translate>
        </b-button>
      </template>
    </page-title>

    <api-list type="shippingOrders" :model="models.shippingOrders" :quick-filters="quickFiltersSetup.shippingOrders" />

  </b-container>
</template>

<script>
import ApiList from '@/components/ApiLists/ApiList'

export default {
  name: 'ShippingOrdersList',
  title() {
    return this.$gettext('Shipment Orders')
  },
  components: {
    ApiList
  },
  props: {
    type: {
      type: String,
      default: 'shippingOrders'
    }
  }
}
</script>
